module.exports = __webpack_public_path__ + "b0463bebc811b14713a0a857e0d9f693.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/SliderDesktopSection/cross-white.png
// module id = WF5f
// module chunks = 0